import request from '@/utils/request'

export function pager(data) {
  return request({
    url: '/api/businessAttendanceRest/list',
    method: 'post',
    data,
  })
}

export function listAll() {
  return request({
    url: '/api/businessAttendanceRest/listAll',
    method: 'post',
  })
}

export function doAdd(data) {
  return request({
    url: '/api/businessAttendanceRest/',
    method: 'post',
    data,
  })
}

export function doEdit(data) {
  return request({
    url: '/api/businessAttendanceRest/',
    method: 'put',
    data,
  })
}

export function doDelete(data) {
  return request({
    url: '/api/businessAttendanceRest/' + data,
    method: 'delete',
  })
}
